import { jsx as _jsx } from "react/jsx-runtime";
import { StyledLink } from '../../components/Link/Link';
import { useEffect, useState } from 'react';
const COOKIE_CONSENT_MODAL_INIT_EVENT = 'dccmCookieConsentModeInit';
const POST_MESSAGE_EVENT_OPEN_MODAL = 'openDisplateCookieConsentModal';
export const CoonsentModeButton = () => {
    const [showConsent, setShowConsent] = useState(false);
    useEffect(() => {
        const consentCallback = () => setShowConsent(true);
        if (window.DisplateConsentMode)
            return setShowConsent(true);
        window.addEventListener(COOKIE_CONSENT_MODAL_INIT_EVENT, consentCallback);
        return () => {
            window.removeEventListener(COOKIE_CONSENT_MODAL_INIT_EVENT, consentCallback);
        };
    }, []);
    if (!showConsent)
        return null;
    const onClick = () => {
        window.postMessage(POST_MESSAGE_EVENT_OPEN_MODAL);
    };
    return (_jsx(StyledLink, Object.assign({ as: "button", onClick: onClick }, { children: "Edit consent" }), void 0));
};
//# sourceMappingURL=ConsentModeButton.js.map